/* API client with cookie-based sessions. All requests are credentialed. */
const BASE = import.meta.env.VITE_API_BASE || '/api';
export class ApiError extends Error {
    status;
    body;
    constructor(status, message, body) {
        super(message);
        this.status = status;
        this.body = body;
    }
}
async function request(method, path, body) {
    const res = await fetch(`${BASE}${path}`, {
        method,
        credentials: 'include',
        headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    const text = await res.text();
    const parsed = text ? safeJSON(text) : null;
    if (!res.ok) {
        const msg = parsed?.error
            ? typeof parsed.error === 'string'
                ? parsed.error
                : JSON.stringify(parsed.error)
            : res.statusText;
        throw new ApiError(res.status, msg, parsed);
    }
    return parsed;
}
function safeJSON(s) {
    try {
        return JSON.parse(s);
    }
    catch {
        return s;
    }
}
export const api = {
    get: (path) => request('GET', path),
    post: (path, body) => request('POST', path, body ?? {}),
    patch: (path, body) => request('PATCH', path, body ?? {}),
    put: (path, body) => request('PUT', path, body ?? {}),
    del: (path) => request('DELETE', path),
};
